import { createSelector } from '@reduxjs/toolkit';
import { EFacilityType, FDealType, FOfferType, isDailyrent } from '../../../../packages/JsonQuery';
import { selectDealType, selectOfferType } from 'shared/selectors/jsonQuery';

interface IFacilityOption {
  label: string;
  value: EFacilityType;
  isAvailable?: (dealType: FDealType, offerType: FOfferType) => boolean;
}

const PARKING_OFFER_TYPES = FOfferType.Flat | FOfferType.Room | FOfferType.Bed;

const isNotDailyrent = (dealType: FDealType): boolean => !isDailyrent(dealType);

const OPTIONS: IFacilityOption[] = [
  { label: 'Кондиционер', value: EFacilityType.Conditioner },
  { label: 'Без мебели', value: EFacilityType.WithoutFurniture, isAvailable: isNotDailyrent },
  { label: 'Интернет', value: EFacilityType.Internet },
  { label: 'Холодильник', value: EFacilityType.Fridge },
  { label: 'Комнатная мебель', value: EFacilityType.RoomFurniture, isAvailable: isNotDailyrent },
  { label: 'Телефон', value: EFacilityType.Phone, isAvailable: isNotDailyrent },
  { label: 'Посудомоечная машина', value: EFacilityType.Dishwasher },
  { label: 'Кухонная мебель', value: EFacilityType.KitchenFurniture },
  { label: 'Телевизор', value: EFacilityType.TV },
  { label: 'Стиральная машина', value: EFacilityType.Washer },
  {
    label: 'Парковка',
    value: EFacilityType.Parking,
    isAvailable: (dealType, offerType) => isDailyrent(dealType) && (offerType & PARKING_OFFER_TYPES) !== 0,
  },
];

export const selectFacilitiesOptions = createSelector([selectDealType, selectOfferType], (dealType, offerType) =>
  OPTIONS.filter(option => !option.isAvailable || option.isAvailable(dealType, offerType)).map(({ label, value }) => ({
    label,
    value,
  })),
);
